import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { rem } from 'approot/shared/style';
import {
  grey1,
  grey4,
  grey7,
  grey10,
  purple7,
} from 'approot/shared/styles/colours.style';
import { LAYOUT_HEADER_HEIGHT } from 'approot/shared/layout/layout.styles';
import {
  ACTIVITY_BUILDER_SETTINGS_WIDTH,
  ACTIVITY_BUILDER_SETTINGS_DRAWER_Z_INDEX,
} from '../activity-builder.constants';
import { SecondaryBaseStyled } from 'approot/shared/styles/buttons/secondary-button.style';
import {
  font12,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';
import { spacing4, spacing8 } from 'approot/shared/styles/spacing.style';
import { FlexColumn, flexColumnCss } from 'approot/shared/styles/flex.style';
import { standardFocusState } from 'approot/shared/styles/borders.style';

export const SettingsDrawer = styled(FlexColumn).attrs({
  as: 'aside',
})`
  background-color: ${grey1};
  border-left: 1px solid ${grey4};
  justify-content: space-between;
  padding: ${rem(spacing4)};
  position: fixed;
  top: ${rem(LAYOUT_HEADER_HEIGHT)};
  bottom: 0;
  right: 0;
  overflow: auto;
  width: ${rem(ACTIVITY_BUILDER_SETTINGS_WIDTH)};
  z-index: ${ACTIVITY_BUILDER_SETTINGS_DRAWER_Z_INDEX};

  & > div {
    width: 100%;
  }
`;

type SettingsDrawerButtonProps = {
  $isActive: boolean;
};
export const SettingsDrawerButton = styled.button<SettingsDrawerButtonProps>`
  ${SecondaryBaseStyled}
  ${font12}
  ${flexColumnCss}
  ${standardFocusState}

  border: none;
  color: ${grey7};
  gap: ${rem(spacing8)};
  height: auto;
  margin-bottom: ${rem(spacing8)};
  min-height: ${rem(71)};
  min-width: auto;
  padding-left: 0;
  padding-right: 0;
  white-space: normal;
  width: 100%;

  ${({ $isActive }) =>
    $isActive
      ? `
      color: ${grey10};
      font-weight: ${fontWeightMedium};
      svg {
        stroke: none;
      }
    `
      : `
      svg, svg path {
        stroke: ${grey7};
      }
  `}
`;

export const SettingsDrawerLink = styled(Link)<SettingsDrawerButtonProps>`
  ${SecondaryBaseStyled}
  ${font12}
  ${flexColumnCss}
  ${standardFocusState}

  border: none;
  color: ${grey7};
  gap: ${rem(spacing8)};
  height: auto;
  margin-bottom: ${rem(spacing8)};
  min-height: ${rem(71)};
  min-width: auto;
  white-space: normal;
  width: 100%;
  text-decoration: none;

  ${({ $isActive }) =>
    $isActive
      ? `
      color: ${grey10};
      font-weight: ${fontWeightMedium};
      svg {
        stroke: none;
      }
    `
      : `
      svg, svg path {
        stroke: ${grey7};
      }
  `}
`;

export const SettingsDrawerEmptyState = styled(FlexColumn)`
  img {
    width: ${rem(120)};
  }
`;

export const SettingsDrawerBackgroundButton = styled(SettingsDrawerButton)`
  svg,
  svg path {
    stroke: none;
  }

  ${({ $isActive }) =>
    $isActive
      ? `
      svg, svg path {
        fill: ${purple7};
      }
    `
      : `
      svg, svg path {
        fill: ${grey7};
      }
  `}
`;
